import React from 'react';
import {CgSpinner} from 'react-icons/cg';
export function Spinner() {
  return (<CgSpinner className="SCSpinner" />);
}
